import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

export default function VaultLicenseError() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        bgcolor: theme.palette.colors.info[100],
        border: '1px solid',
        borderColor: theme.palette.colors.primary[700],
        borderRadius: 1,
        p: 6,
        textAlign: 'center',
        mt: 2,
      }}
    >
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: theme.palette.background.paper,
          borderRadius: '50%',
          width: 64,
          height: 64,
          mb: 2,
        }}
      >
        <BadgeOutlinedIcon
          sx={{ fontSize: 32, color: theme.palette.colors.primary[700] }}
        />
      </Box>
      <Typography
        variant="h6"
        fontWeight={500}
        gutterBottom
        sx={{ color: theme.palette.colors.neutral[800] }}
      >
        Action Required: Google Vault License Needed
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={2}>
        We couldn't export this user's data because your organization doesn't
        have an active Google Vault license for this account.
      </Typography>
      <Link
        href="https://support.google.com/vault/answer/2462365"
        target="_blank"
        rel="noopener noreferrer"
        underline="always"
        sx={{ color: theme.palette.colors.primary[600] }}
      >
        Learn More
      </Link>
    </Box>
  );
}
